module.exports = __webpack_public_path__ + "img/電気回路_4_5_5.ad7d614e.png";